import React, { useContext } from 'react'
import { useUpdateSchoolClass } from '@hooks/mutations/useUpdateSchoolClass'
import { AppContext } from '@state/context'
import { closePanel } from '@state/actions/panelsActions'
import { PANELS } from '@helpers/constants'
import { useSchoolClass } from '@hooks/useSchoolClass'
import AddStudentToSchoolResourcePanel from '.'

const AddStudentToSchoolClassPanel = () => {
  const [state, dispatch] = useContext(AppContext)
  const {
    panels: {
      panelData: { schoolId, schoolClassId },
    },
  } = state
  const { schoolClass } = useSchoolClass(schoolClassId)
  const { post } = useUpdateSchoolClass()

  const onSubmit = async (data) => {
    const studentIdsToConnect = data.students.reduce(
      (acc, student) =>
        Object.prototype.hasOwnProperty.call(student, 'value')
          ? [...acc, student.value]
          : acc,
      []
    )

    const res = await post({
      id: schoolClassId,
      students: { connect: studentIdsToConnect },
    })

    if (res.success) dispatch(closePanel(PANELS.ADD_STUDENT_TO_SCHOOL_CLASS))
  }

  return (
    <AddStudentToSchoolResourcePanel
      resource={schoolClass}
      handleSubmit={onSubmit}
      schoolId={schoolId}
      panelType={PANELS.ADD_STUDENT_TO_SCHOOL_CLASS}
    />
  )
}

export default AddStudentToSchoolClassPanel
